import http from '@plugin/axios'

function getList(list: any[] = []) {
  const map = new Map()
  list.forEach(item => {
    const cell = map.get(item.checkApplyNo)
    if (cell) {
      cell.push(item)
    } else {
      map.set(item.checkApplyNo, [item])
    }
  })
  const result = [...map.values()].map(item => {
    const head = item[0] || {}
    return {
      ...head,
      list: item
    }
  })
  return Object.freeze(result)
}

export default async function getData(params: any) {
  const info = await http<any>({
    url: '/srmCheckApply/getCheckApplyBodyPage',
    baseURL: process.env.VUE_APP_PURCHASE_API,
    data: params
  })
  // checkApplyNo
  return {
    ...info,
    records: Object.freeze(getList(info.records))
  }
}
